import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IfYouDontHaveGmail from '../general/IfYouDontHaveGmail';
import Grid from '@material-ui/core/Grid';
import IntroLoginButton from './IntroLoginButton'
import NonGoogleLoginForm from './NonGoogleLoginForm'
import { VALIDATION_URL } from '../../client_url_constant'

import { withRouter } from 'react-router';

const styles = theme => ({
  root: {
    flexGrow: 1,
    textAlign:'center',
  },
  title:{
    textAlign:'center',
    fontSize:20,
  },
  text:{
    textAlign: 'center'
  },
  button:{
    textAlign: 'center'
  }
})



  class Intro extends Component{
    constructor(props){
      super(props)
      this.state={
        googleLogin:true,
        failedLogin:false,
      }
      this.nonGoogleLogin = this.nonGoogleLogin.bind(this)
      this.confirmUserEmail = this.confirmUserEmail.bind(this)
    }

    nonGoogleLogin(){
      this.setState({
        googleLogin:false,
      })
    }

    async confirmUserEmail(email){
      let body = JSON.stringify({
        email: email,
      });
      let method = "POST";
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      try {
        const res = await fetch(VALIDATION_URL, {method, headers, body});
        if (res.status === 400) throw new Error('Email does not match')

        const json = await res.json();

        // base64でエンコードしたEmailをセッションストレージに保存
        sessionStorage.setItem('ad_tst_ref', json.encoded_email);
        const redirectUrl = json.quiz_url;
        this.props.history.push(redirectUrl);
      } catch (err) {
        console.error(err)
        this.setState({
          failedLogin:true,
        })
      }
    }

    render(){
      const { classes } = this.props;

      let loginChoice = (this.state.googleLogin)?
      <div>
      <h2 className={classes.text}>Google Account もしくは Email でログインして、試験を開始してください。</h2>
      <Grid container spacing={24}>
        <Grid item xs={3} />
        <Grid item xs={3}><IntroLoginButton /></Grid>
        <Grid item xs={3}><IfYouDontHaveGmail clickFunc={this.nonGoogleLogin}/></Grid>
        <Grid item xs={3} />
      </Grid>
      </div>
      :
      <NonGoogleLoginForm clickFunc={this.confirmUserEmail} failed={this.state.failedLogin}/>

      return(
    <div className={classes.root}>
      <h2 className={classes.title}>ITスキル適正試験</h2>
      {loginChoice}
    </div>

  )}
  }

  Intro.propTypes = {
    classes: PropTypes.object.isRequired
  };

export default withRouter(withStyles(styles, { withTheme: true })(Intro));



// WEBPACK FOOTER //
// ./src/components/Login/Intro.js